// extracted by mini-css-extract-plugin
export default {"tooltipTitle":"OrgVerifiedLogo_tooltipTitle__R+SZX","link":"OrgVerifiedLogo_link__xclnw"};